import { useLocation, useNavigate } from "react-router-dom";
import styles from "../styles/layout.module.css";
import { useEffect, useRef, useState } from "react";
import { ReactComponent as Logo } from "../assets/logo.svg";
import Cross from "../assets/cross.svg";
import { ReactComponent as FB } from "../assets/icon/facbook.svg";
import { ReactComponent as INSTA } from "../assets/icon/insta.svg";
import { ReactComponent as TWITTER } from "../assets/icon/twitter.svg";
import { ReactComponent as LINKEDIN } from "../assets/icon/linkedin.svg";

// interface NavbarProps {}

const Navbar = () => {
  const [menu, setMenu] = useState(false);
  const [global, setGlobal] = useState(true);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const closeTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const navigate = useNavigate();

  const location = useLocation().pathname;
  const serviceCountries = [
    { label: "Dubai", path: "/services/global/dubai" },
    { label: "Australia", path: "/services/global/australia" },
  ];

  const openServicesMenu = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
    setServicesOpen(true);
  };

  const closeServicesMenu = () => {
    closeTimer.current = setTimeout(() => {
      setServicesOpen(false);
    }, 180);
  };

  useEffect(() => {
    setServicesOpen(false);
    setMobileServicesOpen(false);
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  }, [location]);

  useEffect(() => {
    return () => {
      if (closeTimer.current) {
        clearTimeout(closeTimer.current);
      }
    };
  }, []);

  return (
    <>
      {location === "/" && global && (
        <div
          className="w-full h-8 bg-[#BB9C71] z-[120] text-center text-xs flex justify-center items-center text-white
                fixed top-0 left-0"
          style={{
            fontFamily: "Josefin Sans, sans-serif",
          }}
        >
          Bion Advisors are now in&nbsp;
          <a href="/services/global/dubai" className="underline">
            Dubai
          </a>
          <span className="mx-2">&amp;</span>
          <a href="/services/global/australia" className="underline">
            Australia
          </a>
          .
          <div
            className="absolute right-3 top-0 bottom-0 flex items-center justify-center cursor-pointer"
            onClick={() => setGlobal(false)}
          >
            <img src={Cross} alt="" height={10} width={10} />
          </div>
        </div>
      )}
      <div
        className={`${styles.nav_container} ${
          location === "/" && global ? "top-8" : "top-0"
        }`}
        style={
          menu
            ? { background: "white" }
            : {
                background: "rgba(255, 253, 249, 0.5)",
                backdropFilter: "blur(5px)",
              }
        }
      >
        {/* send logo here to attach here */}
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/");
          }}
        >
          <Logo style={{ height: "40px", width: "100px" }} />
        </div>
        <div style={{ flexGrow: 1 }}></div>
        <ul className={styles.right_nav_elements}>
          <li
            onClick={() => {
              navigate("/");
            }}
            style={{
              borderBottom: location === "/" ? "2px solid #BB9C71" : "none",
              paddingBottom: "4px",
            }}
          >
            Home
          </li>
          <li
            onClick={() => {
              navigate("/services");
            }}
            style={{
              borderBottom: location === "/services" ? "2px solid #BB9C71" : "none",
              paddingBottom: "4px",
            }}
          >
            Services
          </li>
          <li
            className={`${styles.services_nav_item} ${
              servicesOpen ? styles.services_nav_item_open : ""
            }`}
            onMouseEnter={openServicesMenu}
            onMouseLeave={closeServicesMenu}
            style={{
              borderBottom: location.includes("/global") ? "2px solid #BB9C71" : "none",
              paddingBottom: "4px",
            }}
          >
            <span>Global</span>
            <div className={styles.services_dropdown}>
              <div className={styles.services_dropdown_inner}>
                {serviceCountries.map((country) => (
                  <p
                    key={country.path}
                    onClick={() => {
                      navigate(country.path);
                      setServicesOpen(false);
                    }}
                    style={{
                      borderBottom: location === country.path ? "2px solid #BB9C71" : "none",
                      padding: "9px 18px"
                    }}
                  >
                    {country.label}
                  </p>
                ))}
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              navigate("/team");
            }}
            style={{
              borderBottom: location === "/team" ? "2px solid #BB9C71" : "none",
              paddingBottom: "4px",
            }}
          >
            Team
          </li>
          <li
            onClick={() => {
              navigate("/blog");
            }}
            style={{
              borderBottom: location.includes("/blog") ? "2px solid #BB9C71" : "none",
              paddingBottom: "4px",
            }}
          >
            Insights
          </li>
          <li
            onClick={() => {
              navigate("/career");
            }}
            style={{
              borderBottom: location === "/career" ? "2px solid #BB9C71" : "none",
              paddingBottom: "4px",
            }}
          >
            Careers
          </li>
          <li
            onClick={() => {
              navigate("/");
              navigate("#contact");
            }}
          >
            Contact
          </li>
        </ul>
        <div
          className={styles.menu_btn}
          onClick={() => {
            setMenu((val) => !val);
          }}
        >
          <div className={`${styles.one} ${menu ? styles.one_move : {}}`}></div>
          <div
            className={`${styles.two}  ${menu ? styles.two_move : {}}`}
          ></div>
          <div
            className={`${styles.three} ${menu ? styles.three_move : {}}`}
          ></div>
        </div>
      </div>
      <div
        className={`${styles.menu} ${menu ? `${styles.menu_open}` : {}}`}
        style={
          location === "/" && global && menu ? { top: "calc(70px + 2rem)" } : {}
        }
      >
        {menu && (
          <ul className={styles.right_nav_elements_mob}>
            <li
              onClick={() => {
                navigate("/");
                setMenu(false);
              }}
            >
              Home
            </li>
            <li
              onClick={() => {
                navigate("/services");
                setMenu(false);
              }}
            >
              Services
            </li>
            <li
              onClick={() => {
                setMobileServicesOpen((val) => !val);
              }}
              style={{ position: "relative", paddingRight: "5px", paddingLeft: "30px", textAlign: "right" }}
            >
              <span
                style={{
                  position: "absolute",
                  left: "0",
                  top: "50%",
                  transform: mobileServicesOpen ? "translateY(-50%) rotate(180deg)" : "translateY(-50%) rotate(0deg)",
                  transition: "transform 0.2s",
                }}
              >
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L7 7L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <span>Global</span>
            </li>
            {mobileServicesOpen &&
              serviceCountries.map((country) => (
                <li
                  key={country.path}
                  className={styles.mobile_sub_item}
                  onClick={() => {
                    navigate(country.path);
                    setMenu(false);
                  }}
                  style={{
                    borderBottom: location === country.path ? "2px solid #BB9C71" : "1px solid #cd9804"
                  }}
                >
                  {country.label}
                </li>
              ))}
            <li
              onClick={() => {
                navigate("/team");
                setMenu(false);
              }}
            >
              Team
            </li>
            <li
              onClick={() => {
                navigate("/blog");
                setMenu(false);
              }}
            >
              Insights
            </li>
            <li
              onClick={() => {
                navigate("/career");
                setMenu(false);
              }}
            >
              Careers
            </li>
            <li
              onClick={() => {
                navigate("/");
                navigate("#contact");
                setMenu(false);
              }}
            >
              Contact
            </li>
          </ul>
        )}

        {menu && (
          <div className="flex flex-row items-center justify-center gap-4 md:gap-2 pt-4">
            <a
              href={"https://www.facebook.com/bionadvisorsofficial/"}
              target="_blank"
            >
              <div className={styles.icon_container}>
                <FB className={styles.icons} />
              </div>
            </a>
            <a href="https://www.instagram.com/bion_advisors" target="_blank">
              <div className={styles.icon_container}>
                <INSTA className={styles.icons} />
              </div>
            </a>
            <a href="https://twitter.com/BionAdvisors" target="_blank">
              <div className={styles.icon_container}>
                <TWITTER className={styles.icons} />
              </div>
            </a>
            <a
              href="https://in.linkedin.com/company/bionadvisors"
              target="_blank"
            >
              <div className={styles.icon_container}>
                <LINKEDIN className={styles.icons} />
              </div>
            </a>
          </div>
        )}
      </div>
    </>
  );
};

export default Navbar;
